// Fake terminal logs for the Solport uplink sequence
// Each log entry simulates realistic satellite communication startup

export const FAKE_LOGS = [
  { text: "[BOOT] Initializing orbital uplink daemon v3.9.12", instant: true },
  { text: "[I/O] Scanning LEO relay chain... found 7 nodes", instant: true },
  { text: "[TLS] Negotiating ECDHE key exchange (P-256)" }, // Typed - security is important
  { text: "[TLS] Session established • cipher=TLS_AES_256_GCM_SHA384", pauseAfter: 15 },
  { text: "[GPS] Ephemeris sync Δt=17ms • drift compensated", instant: true },
  { text: "[RADAR] Lunar surface lock • albedo map cached", instant: true },
  { text: "[CPU] Compiling probe firmware :: bundle size 42,912 bytes" }, // Typed - compilation
  { text: "[CPU] ▶ pass 1/3 — optimizing math kernels", instant: true },
  { text: "[CPU] ▶ pass 2/3 — inlining telemetry codecs", instant: true },
  { text: "[CPU] ▶ pass 3/3 — dead code elimination", instant: true, pauseAfter: 20 },
  { text: "[FS] Writing image to EEPROM • checksum 0x8FA3C91E", instant: true },
  { text: "[NET] Multicast ping • round-trip 34ms • loss 0.0%", instant: true },
  { text: "[AIM] Calibrating gimbal • pitch=−2.4° • yaw=15.8°" }, // Typed - calibration
  { text: "[AIM] Star tracker lock • σ=0.002°", instant: true },
  { text: "[TELEM] Uplink bandwidth 18.4 Mbps • SNR 41 dB", instant: true },
  { text: "[SEC] Verifying code-signing cert • CN=SOLPORT" }, // Typed - security
  { text: "[SEC] Signature OK • trust root: SP-ROOT-01", pauseAfter: 15 },
  { text: "[SIM] Dry-run probe launch to M2 • apogee 44,120 km", instant: true },
  { text: "[DB] Caching mission profiles (3) to local store", instant: true },
  { text: "[OK] Uplink ready. Awaiting operator command.", pauseAfter: 25 } // Typed - final message
];
